module.exports = __webpack_public_path__ + "static/media/ciel_logo_colored.71946796.png";